// extracted by mini-css-extract-plugin
export default {"footer-button-mobile-drawer__header":"footer-button-mobile-drawer__header_L6SOl2tL","footer-button-mobile-drawer__body":"footer-button-mobile-drawer__body_Mv8D0PHo"};